// extracted by mini-css-extract-plugin
module.exports = {"md":"CatalogFormBar_md_1ZGTC","ios":"CatalogFormBar_ios_2QCYB","button":"CatalogFormBar_button_B9Y2H","fade":"CatalogFormBar_fade_1sab6"};